import React from 'react';
import './Skeleton.css';

export default function Skeleton({ variant = 'block', size, className = '', style }) {
  const classes = [
    'ki-skeleton',
    variant === 'line' ? 'ki-skeleton--line' : 'ki-skeleton--block',
    size ? `ki-skeleton--${size}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <span className={classes} style={style} aria-hidden="true" />;
}

